// extracted by mini-css-extract-plugin
export default {"holder":"PortfolioLayout_holder__F8vML","subnavHolder":"PortfolioLayout_subnavHolder__7XFQS"};